<template>
    <div class="home">
        <div class="top-white-box"></div>
        <div>
            <DealDetails :dealId="$route.params.id"></DealDetails>
        </div>
        <div class="top-gray-box">
            <h1>Other Deals You Might Like</h1>
        </div>
        <Deals :excludeDeal="$route.params.id" showJoinUs="true" />
    </div>
</template>


<script>
    // @ is an alias to /src
    import Deals from "@/components/Deals.vue";
    import DealDetails from "@/components/DealDetails.vue";
    //import GiveawayBox from '@/components/GiveawayBox.vue';
    import settings from '@/settings';

    export default {
        name: "home",
        data() {
            return {
                isParticipant: false
            }
        },
        components: {
            Deals,
            DealDetails
            //GiveawayBox
        },
        created() {
            var cookie_lastref = this.$cookie.get('MMD_ParticipantRefCode');
            if (cookie_lastref) {
                this.isParticipant = true;
            }
        },
        computed: {
            settings: function () { return settings; }
        }
    };
</script>